import { render, staticRenderFns } from "./DAO.vue?vue&type=template&id=f81f4122&"
import script from "./DAO.vue?vue&type=script&lang=js&"
export * from "./DAO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports